import { currencyDisplayNames, currencyNames } from "../currencyNames";
import { type Locale } from "../contexts/LocaleContext";

// Localized currency names
const currencyNamesLocalized: Record<Locale, Record<string, string>> = {
  en: currencyDisplayNames,
  ru: {
    australianDollar: "Австралийский доллар",
    bulgarianLev: "Болгарский лев",
    brazilianReal: "Бразильский реал",
    canadianDollar: "Канадский доллар",
    swissFranc: "Швейцарский франк",
    chineseYuan: "Китайский юань",
    czechKoruna: "Чешская крона",
    danishKrone: "Датская крона",
    euro: "Евро",
    britishPound: "Британский фунт",
    hongKongDollar: "Гонконгский доллар",
    hungarianForint: "Венгерский форинт",
    indonesianRupiah: "Индонезийская рупия",
    israeliShekel: "Израильский шекель",
    indianRupee: "Индийская рупия",
    icelandicKrona: "Исландская крона",
    japaneseYen: "Японская иена",
    southKoreanWon: "Южнокорейская вона",
    mexicanPeso: "Мексиканское песо",
    malaysianRinggit: "Малайзийский ринггит",
    norwegianKrone: "Норвежская крона",
    newZealandDollar: "Новозеландский доллар",
    philippinePeso: "Филиппинское песо",
    polishZloty: "Польский злотый",
    romanianLeu: "Румынский лей",
    swedishKrona: "Шведская крона",
    singaporeDollar: "Сингапурский доллар",
    thaiBaht: "Тайский бат",
    turkishLira: "Турецкая лира",
    usDollar: "Доллар США",
    southAfricanRand: "Южноафриканский рэнд",
    unitedArabEmiratesDirham: "Дирхам ОАЭ",
    afghanAfghani: "Афганский афгани",
    albanianLek: "Албанский лек",
    armenianDram: "Армянский драм",
    angolanKwanza: "Ангольская кванза",
    argentinePeso: "Аргентинское песо",
    arubanFlorin: "Арубанский флорин",
    azerbaijaniManat: "Азербайджанский манат",
    bosniaAndHerzegovinaConvertibleMark: "Конвертируемая марка Боснии и Герцеговины",
    barbadosDollar: "Барбадосский доллар",
    bangladeshiTaka: "Бангладешская така",
    bahrainiDinar: "Бахрейнский динар",
    burundianFranc: "Бурундийский франк",
    bermudianDollar: "Бермудский доллар",
    bruneiDollar: "Брунейский доллар",
    boliviano: "Боливиано",
    bahamianDollar: "Багамский доллар",
    bhutaneseNgultrum: "Бутанский нгултрум",
    botswanaPula: "Ботсванская пула",
    belarusianRuble: "Белорусский рубль",
    belizeDollar: "Белизский доллар",
    congoleseFranc: "Конголезский франк",
    chileanPeso: "Чилийское песо",
    colombianPeso: "Колумбийское песо",
    costaRicanColon: "Костариканский колон",
    cubanPeso: "Кубинское песо",
    capeVerdeanEscudo: "Эскудо Кабо-Верде",
    djiboutianFranc: "Джибутийский франк",
    dominicanPeso: "Доминиканское песо",
    algerianDinar: "Алжирский динар",
    egyptianPound: "Египетский фунт",
    eritreanNakfa: "Эритрейская накфа",
    ethiopianBirr: "Эфиопский быр",
    fijiDollar: "Доллар Фиджи",
    falklandIslandsPound: "Фунт Фолклендских островов",
    georgianLari: "Грузинский лари",
    ghanaianCedi: "Ганский седи",
    gibraltarPound: "Гибралтарский фунт",
    gambianDalasi: "Гамбийский даласи",
    guineanFranc: "Гвинейский франк",
    guatemalanQuetzal: "Гватемальский кетцаль",
    guyaneseDollar: "Гайанский доллар",
    honduranLempira: "Гондурасская лемпира",
    haitianGourde: "Гаитянский гурд",
    iraqiDinar: "Иракский динар",
    iranianRial: "Иранский риал",
    jamaicanDollar: "Ямайский доллар",
    jordanianDinar: "Иорданский динар",
    kenyanShilling: "Кенийский шиллинг",
    kyrgyzstaniSom: "Киргизский сом",
    cambodianRiel: "Камбоджийский риель",
    comoroFranc: "Коморский франк",
    northKoreanWon: "Северокорейская вона",
    kuwaitiDinar: "Кувейтский динар",
    caymanIslandsDollar: "Доллар Каймановых островов",
    kazakhstaniTenge: "Казахстанский тенге",
    laoKip: "Лаосский кип",
    lebanesePound: "Ливанский фунт",
    sriLankanRupee: "Шри-ланкийская рупия",
    liberianDollar: "Либерийский доллар",
    lesothoLoti: "Лоти Лесото",
    libyanDinar: "Ливийский динар",
    moroccanDirham: "Марокканский дирхам",
    moldovanLeu: "Молдавский лей",
    malagasyAriary: "Малагасийский ариари",
    macedonianDenar: "Македонский денар",
    myanmarKyat: "Мьянманский кьят",
    mongolianTGrG: "Монгольский тугрик",
    macanesePataca: "Патака Макао",
    mauritanianOuguiya: "Мавританская угия",
    mauritianRupee: "Маврикийская рупия",
    maldivianRufiyaa: "Мальдивская руфия",
    malawianKwacha: "Малавийская квача",
    mozambicanMetical: "Мозамбикский метикал",
    namibianDollar: "Намибийский доллар",
    nigerianNaira: "Нигерийская найра",
    nicaraguanCRdoba: "Никарагуанская кордоба",
    nepaleseRupee: "Непальская рупия",
    omaniRial: "Оманский риал",
    panamanianBalboa: "Панамский бальбоа",
    peruvianSol: "Перуанский соль",
    papuaNewGuineanKina: "Кина Папуа-Новой Гвинеи",
    pakistaniRupee: "Пакистанская рупия",
    paraguayanGuaran: "Парагвайский гуарани",
    qatariRiyal: "Катарский риал",
    serbianDinar: "Сербский динар",
    russianRuble: "Российский рубль",
    rwandanFranc: "Руандийский франк",
    saudiRiyal: "Саудовский риал",
    solomonIslandsDollar: "Доллар Соломоновых островов",
    seychellesRupee: "Сейшельская рупия",
    sudanesePound: "Суданский фунт",
    saintHelenaPound: "Фунт Святой Елены",
    sierraLeoneanLeone: "Сьерра-леонский леоне",
    somalianShilling: "Сомалийский шиллинг",
    surinameseDollar: "Суринамский доллар",
    southSudanesePound: "Южносуданский фунт",
    sOTomAndPrNcipeDobra: "Добра Сан-Томе и Принсипи",
    salvadoranColN: "Сальвадорский колон",
    syrianPound: "Сирийский фунт",
    swaziLilangeni: "Свазилендский лилангени",
    tajikistaniSomoni: "Таджикский сомони",
    turkmenistanManat: "Туркменский манат",
    tunisianDinar: "Тунисский динар",
    tonganPaAnga: "Тонганская паанга",
    trinidadAndTobagoDollar: "Доллар Тринидада и Тобаго",
    newTaiwanDollar: "Новый тайваньский доллар",
    tanzanianShilling: "Танзанийский шиллинг",
    ukrainianHryvnia: "Украинская гривна",
    ugandanShilling: "Угандийский шиллинг",
    uruguayanPeso: "Уругвайское песо",
    uzbekistaniSum: "Узбекский сум",
    venezuelanSovereignBolVar: "Венесуэльский суверенный боливар",
    vietnameseNg: "Вьетнамский донг",
    vanuatuVatu: "Вануатский вату",
    samoanTala: "Самоанская тала",
    arabAccountingDinar: "Арабский учетный динар",
    cfaFrancBeac: "Франк КФА BEAC",
    eastCaribbeanDollar: "Восточнокарибский доллар",
    caribbeanGuilder: "Карибский гульден",
    cfaFrancBceao: "Франк КФА BCEAO",
    cfpFranc: "Франк КФП",
    yemeniRial: "Йеменский риал",
    zambianKwacha: "Замбийская квача",
  },
  cs: {
    australianDollar: "Australský dolar",
    bulgarianLev: "Bulharský lev",
    brazilianReal: "Brazilský real",
    canadianDollar: "Kanadský dolar",
    swissFranc: "Švýcarský frank",
    chineseYuan: "Čínský jüan",
    czechKoruna: "Česká koruna",
    danishKrone: "Dánská koruna",
    euro: "Euro",
    britishPound: "Britská libra",
    hongKongDollar: "Hongkongský dolar",
    hungarianForint: "Maďarský forint",
    indonesianRupiah: "Indonéská rupie",
    israeliShekel: "Izraelský šekel",
    indianRupee: "Indická rupie",
    icelandicKrona: "Islandská koruna",
    japaneseYen: "Japonský jen",
    southKoreanWon: "Jihokorejský won",
    mexicanPeso: "Mexické peso",
    malaysianRinggit: "Malajsijský ringgit",
    norwegianKrone: "Norská koruna",
    newZealandDollar: "Novozélandský dolar",
    philippinePeso: "Filipínské peso",
    polishZloty: "Polský zlotý",
    romanianLeu: "Rumunský leu",
    swedishKrona: "Švédská koruna",
    singaporeDollar: "Singapurský dolar",
    thaiBaht: "Thajský baht",
    turkishLira: "Turecká lira",
    usDollar: "Americký dolar",
    southAfricanRand: "Jihoafrický rand",
    unitedArabEmiratesDirham: "Dirham Spojených arabských emirátů",
    afghanAfghani: "Afghánský afghání",
    albanianLek: "Albánský lek",
    armenianDram: "Arménský dram",
    angolanKwanza: "Angolská kwanza",
    argentinePeso: "Argentinské peso",
    arubanFlorin: "Arubský florin",
    azerbaijaniManat: "Ázerbájdžánský manat",
    bosniaAndHerzegovinaConvertibleMark: "Konvertibilní marka Bosny a Hercegoviny",
    barbadosDollar: "Barbadoský dolar",
    bangladeshiTaka: "Bangladéšská taka",
    bahrainiDinar: "Bahrajnský dinár",
    burundianFranc: "Burundský frank",
    bermudianDollar: "Bermudský dolar",
    bruneiDollar: "Brunejský dolar",
    boliviano: "Boliviano",
    bahamianDollar: "Bahamský dolar",
    bhutaneseNgultrum: "Bhútánský ngultrum",
    botswanaPula: "Botswanská pula",
    belarusianRuble: "Běloruský rubl",
    belizeDollar: "Belizský dolar",
    congoleseFranc: "Konžský frank",
    chileanPeso: "Chilské peso",
    colombianPeso: "Kolumbijské peso",
    costaRicanColon: "Kostarický colón",
    cubanPeso: "Kubánské peso",
    capeVerdeanEscudo: "Kapverdské escudo",
    djiboutianFranc: "Džibutský frank",
    dominicanPeso: "Dominikánské peso",
    algerianDinar: "Alžírský dinár",
    egyptianPound: "Egyptská libra",
    eritreanNakfa: "Eritrejská nakfa",
    ethiopianBirr: "Etiopský birr",
    fijiDollar: "Fidžijský dolar",
    falklandIslandsPound: "Falklandská libra",
    georgianLari: "Gruzínský lari",
    ghanaianCedi: "Ghanský cedi",
    gibraltarPound: "Gibraltarská libra",
    gambianDalasi: "Gambijský dalasi",
    guineanFranc: "Guinejský frank",
    guatemalanQuetzal: "Guatemalský quetzal",
    guyaneseDollar: "Guyanský dolar",
    honduranLempira: "Honduraská lempira",
    haitianGourde: "Haitský gourde",
    iraqiDinar: "Irácký dinár",
    iranianRial: "Íránský rijál",
    jamaicanDollar: "Jamajský dolar",
    jordanianDinar: "Jordánský dinár",
    kenyanShilling: "Keňský šilink",
    kyrgyzstaniSom: "Kyrgyzský som",
    cambodianRiel: "Kambodžský riel",
    comoroFranc: "Komorský frank",
    northKoreanWon: "Severokorejský won",
    kuwaitiDinar: "Kuvajtský dinár",
    caymanIslandsDollar: "Kajmanský dolar",
    kazakhstaniTenge: "Kazachstánský tenge",
    laoKip: "Laoský kip",
    lebanesePound: "Libanonská libra",
    sriLankanRupee: "Srílanská rupie",
    liberianDollar: "Liberijský dolar",
    lesothoLoti: "Lesothský loti",
    libyanDinar: "Libyjský dinár",
    moroccanDirham: "Marocký dirham",
    moldovanLeu: "Moldavský leu",
    malagasyAriary: "Madagaskarský ariary",
    macedonianDenar: "Makedonský denár",
    myanmarKyat: "Myanmarský kyat",
    mongolianTGrG: "Mongolský tugrik",
    macanesePataca: "Macajská pataca",
    mauritanianOuguiya: "Mauritánská ouguiya",
    mauritianRupee: "Mauricijská rupie",
    maldivianRufiyaa: "Maledivská rufiyaa",
    malawianKwacha: "Malawijská kwacha",
    mozambicanMetical: "Mosambický metical",
    namibianDollar: "Namibijský dolar",
    nigerianNaira: "Nigerijská naira",
    nicaraguanCRdoba: "Nikaragujská córdoba",
    nepaleseRupee: "Nepálská rupie",
    omaniRial: "Ománský rijál",
    panamanianBalboa: "Panamský balboa",
    peruvianSol: "Peruánský sol",
    papuaNewGuineanKina: "Papua-Novoguinejská kina",
    pakistaniRupee: "Pákistánská rupie",
    paraguayanGuaran: "Paraguayský guaraní",
    qatariRiyal: "Katarský rijál",
    serbianDinar: "Srbský dinár",
    russianRuble: "Ruský rubl",
    rwandanFranc: "Rwandský frank",
    saudiRiyal: "Saúdský rijál",
    solomonIslandsDollar: "Dolar Šalomounových ostrovů",
    seychellesRupee: "Seychelská rupie",
    sudanesePound: "Súdánská libra",
    saintHelenaPound: "Libra Svaté Heleny",
    sierraLeoneanLeone: "Sierraleonský leone",
    somalianShilling: "Somálský šilink",
    surinameseDollar: "Surinamský dolar",
    southSudanesePound: "Jiho súdánská libra",
    sOTomAndPrNcipeDobra: "Dobra Svatého Tomáše a Princova ostrova",
    salvadoranColN: "Salvadorský colón",
    syrianPound: "Syrská libra",
    swaziLilangeni: "Svazijský lilangeni",
    tajikistaniSomoni: "Tádžický somoni",
    turkmenistanManat: "Turkmenistánský manat",
    tunisianDinar: "Tuniský dinár",
    tonganPaAnga: "Tonžská paʻanga",
    trinidadAndTobagoDollar: "Dolar Trinidadu a Tobaga",
    newTaiwanDollar: "Nový tchajwanský dolar",
    tanzanianShilling: "Tanzanský šilink",
    ukrainianHryvnia: "Ukrajinská hřivna",
    ugandanShilling: "Ugandský šilink",
    uruguayanPeso: "Uruguayské peso",
    uzbekistaniSum: "Uzbecký sum",
    venezuelanSovereignBolVar: "Venezuelský suverénní bolívar",
    vietnameseNg: "Vietnamský dong",
    vanuatuVatu: "Vanuatský vatu",
    samoanTala: "Samojská tala",
    arabAccountingDinar: "Arabský účetní dinár",
    cfaFrancBeac: "CFA frank BEAC",
    eastCaribbeanDollar: "Východokaribský dolar",
    caribbeanGuilder: "Karibský gulden",
    cfaFrancBceao: "CFA frank BCEAO",
    cfpFranc: "CFP frank",
    yemeniRial: "Jemenský rijál",
    zambianKwacha: "Zambijská kwacha",
  },
};

export function getLocalizedCurrencyName(key: string, locale: Locale = "en"): string {
  return currencyNamesLocalized[locale]?.[key] || currencyDisplayNames[key] || key;
}

export function getCurrencyLabel(key: string, code: string, locale: Locale = "en"): string {
  const name = getLocalizedCurrencyName(key, locale);
  return `${name} (${code})`;
}

/**
 * Returns an array of {key, code, label} sorted by localized label,
 * with CZK, EUR, USD, GBP fixed at the top.
 */
export function getSortedCurrencies(locale: Locale = "en") {
  const topKeys = ["czechKoruna", "euro", "usDollar", "britishPound"];
  
  const allCurrencies = Object.entries(currencyNames).map(([key, code]) => ({
    key,
    code,
    label: getCurrencyLabel(key, code, locale),
    name: getLocalizedCurrencyName(key, locale)
  }));

  const topList = allCurrencies
    .filter(c => topKeys.includes(c.key))
    .sort((a, b) => topKeys.indexOf(a.key) - topKeys.indexOf(b.key)); // Maintain specific order

  const otherList = allCurrencies
    .filter(c => !topKeys.includes(c.key))
    .sort((a, b) => a.name.localeCompare(b.name, locale));

  return [...topList, ...otherList];
}
